import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { getShoppingCenters } from 'hooks/useUser';
import { useApi } from 'hooks/useApi';
import FacilityCalendarApi from 'libs/api/facility/calendar';
import FacilityCalendarAdapter from './facility-calendar.adapter';

export const useFacilityCalendar = () => {
  const { t } = useTranslation();
  const shoppingCenters = useRecoilValue(getShoppingCenters);
  const { data } = useApi({
    resourceKey: 'data',
    isMainPage: true,
    api: new FacilityCalendarApi(),
    adapter: FacilityCalendarAdapter,
  });

  const filters = useMemo(() => [
    {
      title: t('Outlet Village'),
      type: 'select',
      name: 'shopping_center_id',
      values: shoppingCenters.map((i) => ({
        value: i.id,
        title: i.title,
      })),
    },
  ], [shoppingCenters, t]);

  return {
    filters,
    data,
  };
};
